import React, { useState, useEffect } from "react";
import { Button } from "components/common/Button";
import { UpdatePreferencesBody } from "target_wasm";
import {
  fetchNotificationPreferences,
  setNotificationPreferences,
} from "@/components/main/utils/notifications/NotificationsApi";
import { Checkbox } from "@/components/main/utils/notifications/SettingItem";
import { SettingsRow } from "./SettingsRow";
import { createLogger } from "debug/DebugingLogger";
import { showNotificationGlobal } from "stores/useNotificationStore";

const log = createLogger("SettingsDialog");

export const NotificationsTab: React.FC = () => {
  const [emailEnabled, setEmailEnabled] = useState(false);
  const [appEnabled, setAppEnabled] = useState(false);
  const [initialEmail, setInitialEmail] = useState(false);
  const [initialApp, setInitialApp] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  useEffect(() => {
    fetchNotificationPreferences()
      .then((prefs) => {
        const emailVal = prefs.in_email_notification;
        const appVal = prefs.enabled;
        setEmailEnabled(emailVal);
        setAppEnabled(appVal);
        setInitialEmail(emailVal);
        setInitialApp(appVal);
      })
      .catch((err) => log.error("Failed to load preferences: %o", err));
  }, []);

  const isDirty = emailEnabled !== initialEmail || appEnabled !== initialApp;

  const handleSave = async () => {
    setIsSaving(true);
    try {
      const prefs = UpdatePreferencesBody.new_js(emailEnabled, appEnabled);
      await setNotificationPreferences(prefs);
      setInitialEmail(emailEnabled);
      setInitialApp(appEnabled);
      showNotificationGlobal("Notification preferences saved", "success");
    } catch (error) {
      log.error("Failed to save preferences: %o", error);
      showNotificationGlobal("Failed to save preferences", "error");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="flex flex-col gap-4">
      <SettingsRow
        label="Email Notifications"
        description="Receive notifications via email"
        control={<Checkbox checked={emailEnabled} onChange={setEmailEnabled} />}
      />
      <SettingsRow
        label="App Notifications"
        description="Receive notifications in Mycorr"
        control={<Checkbox checked={appEnabled} onChange={setAppEnabled} />}
      />

      <div className="flex justify-end">
        <Button
          onClick={handleSave}
          disabled={!isDirty}
          loading={isSaving}
          variant="primary"
          size="md"
        >
          Save
        </Button>
      </div>
    </div>
  );
};
